
/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: vue-router 路由管理
 * @Author: wangwz@knowdee.com
 * @Date: 2022-05-05 15:38:02
 * @LastEditTime: 2023-10-09 14:11:23
 * @FilePath: /client-h5-v2/src/router/index.ts
 */

import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store/index'

// 区分当前项目使用mobile端样式结构还是PC端样式结构
const routerToComponents = () => {
  // 设备名称
  const deviceName = store.getters['global/device']
  // 是否为移动手机
  const isMobilePhone = deviceName === 'mobile_phone'
  if (isMobilePhone) {
    return () => import('@/components-mobile/home/HomeIndex.vue')
  } else {
    return () => import('@/components-pc/home/HomeIndex.vue')
  }
}
const component = routerToComponents()

const routes: Array<RouteRecordRaw> = [
  {
    path: '/webview',
    name: 'webView',
    component: () => import('@/components-webview/layout/TheIndex.vue')
  },
  {
    path: '/',
    name: 'bot',
    component: component,
    meta: {
      requiresAuth: true // 需要登录才能访问的路由
    }
  },
  {
    path: '/robbie',
    name: 'robbie',
    component: component,
    meta: {
      requiresAuth: true // 需要登录才能访问的路由
    }
  },
  {
    path: '/roobieLogin',
    name: 'roobieLogin',
    component: () => import('@/components/login/RoobieLogin.vue')
  },
  {
    path: '/moli',
    name: 'moli',
    component: component
  },
  {
    path: '/lena',
    name: 'lena',
    component: component
  },
  {
    path: '/lmsa',
    name: 'lmsa',
    component: component
  },
  {
    path: '/lenovoapp',
    name: 'lenovoapp',
    component: component
  },
  {
    path: '/lenovohelplib',
    name: 'lenovohelplib',
    component: component
  },
  {
    path: '/tablet',
    name: 'tablet',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/helloyou',
    name: 'helloyou',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/sitelecom',
    name: 'sitelecom',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/forum',
    name: 'forum',
    component: component
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/familySpace',
    name: 'familySpace',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/vantage',
    name: '/vantage',
    component: component
  },
  {
    path: '/teams',
    name: 'teams',
    component: component
  },
  {
    path: '/xiaole',
    name: 'xiaole',
    component: component
  },
  // 引导页面
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/components-special/ZhilianGuide.vue')
  },
  {
    path: '/zhilian',
    name: 'zhilian',
    component: component
  },
  {
    path: '/xiaole-pc',
    name: 'xiaolePc',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/xiaole-mobile',
    name: 'xiaoleMobile',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/webinpage',
    name: 'webinpage',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/teams',
    name: 'teams',
    component: () => import('@/components-teams/home/HomeIndex.vue')
  },
  {
    path: '/fuguan',
    name: 'fuguan',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/fumaohui',
    name: 'fumaohui',
    component: () => import('@/components-special/FumaohuiRootIndex.vue')
  },
  {
    path: '/fumaohuiOld',
    name: 'fumaohuiOld',
    component: () => import('@/components-special/FuMaoHui.vue')
  },
  {
    path: '/pocsystem',
    name: 'pocsystem',
    component: () => import('@/components-special/FuMaoHuiV2System.vue')
  },
  {
    path: '/dialogSystem',
    name: 'dialogSystem',
    component: () => import('@/components-dialog-system/home/HomeIndex.vue')
  }
]

const router = createRouter({
  history: createWebHistory(window.botV2GlobalProperties.BASE_PATH),
  routes
})
// router.beforeEach((to, from, next) => {
//   console.log(JSON.stringify(store.getters['global/pageConfig']))
//   next()
// })

router.beforeEach((to, from, next) => {
  console.log('login 状态', store.getters['login/status'])
  console.log(to.meta.requiresAuth)
  // 检查路由是否需要登录
  if (to.meta.requiresAuth && !store.getters['login/status']) {
    // 如果需要登录但用户未登录，重定向到登录页面
    next({ path: '/roobieLogin', query: store.getters['global/params']})
  } else {
    next()
  }
})
export default router
